import { unreverseCode } from '@/utils/cryptoUnreverse';
import request from '@/utils/request';
import { stringify } from 'qs';
export async function accountLogin(payload) {
  payload.password = unreverseCode(payload.password);
  return request(`/iwms-account/account/login/login?${stringify(payload)}&deviceType=WEB`, {
    method: 'POST',
  });
}

export async function needCaptchaAuth(payload) {
  return request(`/iwms-account/account/login/needCaptchaAuth?loginAccount=${payload}`, {
    method: 'POST'
  });
}

//海鼎登录
export async function headingLogin(payload) {
  payload.password = unreverseCode(payload.password);
  return request(`/iwms-account/account/login/heading/login?${stringify(payload)}&deviceType=WEB`, {
    method: 'POST',
  });
}

export async function phoneLogin(payload) {
  payload.password = unreverseCode(payload.password);
  return request(`/iwms-account/account/login/captchalogin?${stringify(payload)}&deviceType=WEB`, {
    method: 'POST',
  });
}

export async function forgetPassword(payload) {
  return request(`/iwms-account/account/login/forgetpassword?phone=${payload.phone}&captcha=${payload.captcha}&newPassword=${unreverseCode(payload.newPassword)}`, {
    method: 'POST',
  });
}

export async function modifyPassword(payload) {
  return request(`/iwms-account/account/login/modify?userUuid=${payload.userUuid}&oldPassword=${unreverseCode(payload.oldPassword)}&newPassword=${unreverseCode(payload.newPassword)}`, {
    method: 'POST',
  });
}

export async function switchOrg(payload) {
  return request(`/iwms-account/account/login/switch?userUuid=${payload.userUuid}&orgUuid=${payload.orgUuid}&deviceType=WEB`, {
    method: 'POST',
  });
}

export async function get(payload) {
  return request(`/iwms-account/account/login?${stringify(payload)}`);
}

export async function resetPassword(payload) {
  return request(`/iwms-account/account/login/resetPassword?userUuid=${payload.userUuid}`, {
    method: 'POST',
  });
}

export async function unLock(payload) {
  return request(`/iwms-account/account/login/unLock?userUuid=${payload.userUuid}`, {
    method: 'POST',
  });
}
//转换token
export async function uniLogin(payload) {
  return request(`/iwms-account/account/login/uniLogin?action=change-token&cors-token=${payload}`, {
    method: 'POST',
  });
}
